var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _text, _text2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 169 48",
    enableBackground: "new 0 0 169 48",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#532A73",
    d: "M36.1,7.7c0,3.6-2.9,6.6-6.6,6.6c-3.6,0-6.6-2.9-6.6-6.6s2.9-6.6,6.6-6.6C33.2,1.1,36.1,4,36.1,7.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#5E2D7E",
    d: "M34.4,5.9c0,2.2-2.2,4.1-4.9,4.1c-2.7,0-4.9-1.8-4.9-4.1s2.2-4.1,4.9-4.1C32.2,1.9,34.4,3.7,34.4,5.9z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#532A73",
    d: "M36.2,16.1c-3.6,3.2-8.9,3.6-12.9,0.9c-4.9-3.3-10.7-5.2-17-5.2c-1.1,0-2.2,0.1-3.3,0.2 c-0.4,0-0.5,0.6-0.1,0.8c9.7,3.8,21.6,15.3,27,33.7c0.2,0.7,1.1,0.7,1.3,0c5.3-15.9,18.6-33.7,29.6-40.2c0.4-0.2,0.2-0.8-0.2-0.8 C51.2,6.3,42.7,10.1,36.2,16.1z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#5E2D7E",
    d: "M60.7,5.8c-7.8,1.5-22,16.6-27.5,22.6c-1.2,1.3-3.3,1.4-4.6,0.2c-5.2-4.7-17.7-15.2-25.9-16.4 c9.7,3.7,21.6,15.2,27,33.5c0.2,0.7,1.1,0.7,1.3,0C36.4,29.9,49.7,12.3,60.7,5.8z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#00A64F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: " M49.2,18.3C49.8,20.1,50,22,50,24c0,10-7.1,18.3-16.5,20.3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#00A64F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: " M14.2,9.5c2.3-2.3,5.1-4.1,8.3-5.2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#00A64F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: " M37.2,4.8c2.4,1,4.5,2.4,6.3,4.1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#00A64F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: " M26.4,44.7C16.2,43.4,8.2,34.6,8.2,24c0-2.1,0.3-4.1,0.9-6"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 63.1865 22.4619)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    fill: "#532A73",
    fontFamily: "'Poppins-Regular'",
    fontSize: "17.4406px"
  }, "TOTAL "), /*#__PURE__*/React.createElement("tspan", {
    x: 56.5,
    y: 0,
    fill: "#532A73",
    fontFamily: "'Poppins-Bold'",
    fontSize: "17.4406px"
  }, "CARE"))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 63.1865 40.6035)",
    fill: "#00A64F",
    fontFamily: "'Poppins-Bold'",
    fontSize: "17.4406px"
  }, "ADVISORY")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.c82068f42d24b73ef4634a4f5a2d9e88.svg";
export { ForwardRef as ReactComponent };